export const kycSumsubConstants = {
    SET_IS_LOADING: 'SET_IS_LOADING',
    SET_ERROR: 'SET_ERROR',
    UPDATE_STEP: 'UPDATE_STEP',
};
